import React from 'react';
import { useDispatch } from 'react-redux';
import { saveInitialQueryparams } from '../../actions';
import App from '../../components/App';
const AppContainer = () => {
    const dispatch = useDispatch();

    const saveQueryParams = (query = '') => {
        dispatch(saveInitialQueryparams(query));
    }

    return (
        <App saveQueryParams={saveQueryParams} />
    );
}

export default AppContainer;